<template>
<div ui-view="" class="app-body" id="view">
	<!-- ############ PAGE START-->
		<page-header title="출입위치 관리" description="NTREE 출입 목록과 별개로 VMS 내부적으로 출입 가능한 위치를 관리합니다.">
			<div class="btn-wrap">
				<button class="btn btn-lg line-2" @click="remove()">
						<i class="icon-recyle mr-5"></i> 삭제
				</button>

			</div>
		</page-header>

	<!-- page-body -->
	<div class="page-body ph-30">
		<!-- white content box -->
		<div class="box mt-20">

			<div class="box-header">
				<h3>출입위치 관리</h3>
				<p>VMS 내부에서 별도로 관리하고 싶은 위치를 추가합니다.</p>
				<p>ex) 상황실, 창고 등</p>
			</div>

			<!-- 템플릿, 메일 구분 -->
				<div class="box-body">
					<div class="row">
						<div class="col-2">
							<location-list ref="locationList" :locationList="idcList" @idcSelect="idcSelect" :selected="selectedLocation"/>
						</div>
						<div class="col-10">
							<location-body ref="locationBody" :selectedLocation="selectedLocation" :isAddButton="true" @selectedLocation="selectedLocationChange"/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue'
import LocationList from './location/LocationList.vue';
import LocationBase from '@/components/common/locationBase'
import LocationBody from './location/LocationBody.vue';
export default {
  mixins: [LocationBase],
  props: ['title', 'description'],
	components: {
		PageHeader,
		LocationList,
LocationBody,
	},
	data(){
    return {
      selectedLocation: {},
      idcList: null,
			select2Depth: null,
			select3Depth: [],
			select4Depth: null,
			currentIdcTotalRow:0,
			selectedList: [],
			locationCode: null,
			location: [],
    }
  },
	computed: {
		getFilterd(){
			return (arr)=>{
				return arr.children.filter(x => x.isDeleteYN == "N");
			}
		},
	},
	watch: {
		$route(to, from) {
			if (to.query.locationCode != from.query.locationCode ) {
				debugger;
				var item = null;
				this.locationCode = to.query.locationCode;
				if(this.locationCode)
					item = this.getCodeByItem(this.locationCode);
				this.selectedLocation = item;
				this.$refs.locationBody.idcSelect(item);

			}
		}
	},
	mounted(){
		this.init();
	},
	methods: {
		init(){
			if(this.$route.query.locationCode)
				this.locationCode = this.$route.query.locationCode;
			this.loadLocation();
		},
		async loadLocation(){
			let location = await this.$store.getters['location/location'];
			this.location = location;
			this.idcList = location.filter(x => x.isDeleteYN == "N");
			this.idcSelect();
			this.makeKey();
		},

		idcSelect(item){

			if(!item && this.locationCode){
				item = this.getCodeByItem(this.locationCode);
				debugger;
				this.selectedLocation = item;
				this.$refs.locationBody.idcSelect(item);
			} else{
				if(!item)
					item = this.idcList[0];
			}

			this.$router.push({path: this.$route.path, query: {locationCode: item.locationCode} }).catch(()=>{});
		},

		getCodeByItem(code){
			if(code){
				return this.location.filter(x => x.isDeleteYN == "N" && x.locationCode == code)[0];
			}
		},
		selectedLocationChange(data){
			var list = [];
			Object.keys(data).forEach((key)=>{
				list.push(data[key])
			})
			this.selectedList = list;
			debugger;
		},
		remove(){
			var that = this;
			var o = [];
			o = this.selectedList;
			this.$http.delete('/api/private/location', {data: o}).then((result)=>{
				this.$store.dispatch('location/deleteAllLocation');
				that.noti('삭제되었습니다.', 'success');
				that.$router.go(0);
			})
		}
	}
}
</script>

<style>

</style>
